import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import ShareIcon from '@mui/icons-material/IosShare';
import { Milestone } from 'lib/types';
import { stringToFilename } from 'lib/helpers';

interface Props {
  img?: string;
  onClose: () => void;
  milestone: Milestone;
}

export const MilestoneCardModal = ({
  img, onClose, milestone,
}: Props) => {
  if (!img) return null;

  const fileName = `${stringToFilename(milestone.name)}-milestone.png`;
  const handleShare = async () => {
    try {
      // First try to use the Web Share API if available
      if (navigator.share) {
        try {
          // Fetch the image as a blob
          const response = await fetch(img);
          const blob = await response.blob();
          const file = new File([blob], fileName, { type: 'image/png' });

          // Try to share the file
          await navigator.share({
            title: `Check it out! ${milestone.name} on Gondola!`,
            files: [file],
          });
          return;
        } catch (error: any) {
          if (error.name === 'AbortError') {
            // User canceled the share
            return;
          }
          // If sharing fails, fall back to download
        }
      }

      // Fallback: download the image
      const link = document.createElement('a');
      link.href = img;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error('Error sharing image:', error);
    }
  };

  return (
    <Dialog open>
      <div className="p-4 pt-12 sm:pt-4">
        <div className="absolute right-2 top-2 flex gap-2 z-10">
          <IconButton onClick={handleShare} aria-label="share image" className="btn-primary-outlined uppercase text-sm flex items-center gap-1">
            <ShareIcon />
            <div>Share</div>
          </IconButton>
          <IconButton onClick={onClose} aria-label="close modal">
            <CloseIcon />
          </IconButton>
        </div>
        <h1 className="font-semibold text-xl">Share your accomplishment!</h1>
        <h2 className="mb-4">Tag us @ongondola and #RollTheCredits</h2>
        <img src={img} alt="milestone card" />
      </div>
    </Dialog>
  );
};
